import React, { useEffect, useState } from 'react';
import DataTable, { defaultThemes } from 'react-data-table-component';
import { GetSsotDetailsApi } from '../../Services/allApi'; // Make sure this is correctly imported
import { toast } from 'react-toastify';
import PopOver from '../../Components/PopOver';
import SyncLoader from "react-spinners/SyncLoader";
import '../loaderStyles.css'
import { Icon } from '@iconify/react/dist/iconify.js';

function SsotTable() {
    const [ssotData, setSsotData] = useState([]);

    useEffect(() => {
        GetSsotDetails();
    }, []);

    const GetSsotDetails = async () => {
        const token = sessionStorage.getItem('access_token');
        const reqHeader = {
            'Content-Type': 'application/json',
            'Authorization': `${token}`
        };
        try {
            const result = await GetSsotDetailsApi(reqHeader);
            setSsotData(result?.data?.data);
            console.log(result?.data?.data);
        } catch (error) {
            console.error('Error fetching SSOT details:', error);
            toast.error('Failed to fetch SSOT details.');
        }
    };

    const customStyles = {
        rows: {
            style: {
                '&:nth-child(odd)': {
                    backgroundColor: '#F5F8FA',
                    minHeight: '50px',
                },
                '&:nth-child(even)': {
                    backgroundColor: 'white',
                    minHeight: '50px',
                },
            },
        },
        header: {
            style: {
                minHeight: '4px',
            },
        },
        headRow: {
            style: {
                borderTopStyle: 'solid',
                borderTopWidth: '1px',
                borderTopColor: defaultThemes.default.divider.default,
                backgroundColor: '#18A0FB',
                color: 'white',
                height: '50px',
            },
        },
        headCells: {
            style: {
                '&:not(:last-of-type)': {
                    borderRightStyle: 'solid',
                    borderRightWidth: '1px',
                    borderRightColor: defaultThemes.default.divider.default,
                },
            },
        },
        cells: {
            style: {
                '&:not(:last-of-type)': {
                    borderRightStyle: 'solid',
                    borderRightWidth: '1px',
                    borderRightColor: defaultThemes.default.divider.default,
                },
            },
        },
    };

    const columns = [
        {
            name: 'Sl No',
            selector: row => row.slno,
            sortable: true,
        },
        {
            name: 'Name',
            selector: row => row.name,
            sortable: true,
        },
        // {
        //     name: 'Constituency',
        //     selector: row => row.constituency,
        //     sortable: true,
        // },
        // {
        //     name: 'Gist Of Business',
        //     selector: row => row.business,
        //     sortable: true,
        // },
        {
            name: 'MLA Hostel',
            selector: row => row.hostel,
            sortable: true,
        },
        {
            name: 'Photo',
            selector: row => row.photo,
            sortable: true,
        },
        // {
        //     name: 'Phone Number',
        //     selector: row => row.phone,
        //     sortable: true,
        // },
        {
            name: 'Email',
            selector: row => row.email,
            sortable: true,
        },
    ];

    const data = ssotData?.map((item, index) => {
        return {
            slno: index + 1,
            name: item?.Name,
            constituency: item["Constituency (Constituency No.)"],
            business: item["Gist Of Business (Sessions)"],
            hostel: item["MLA Hostel"],
            photo: <img src={`${item?.Image}`} className='h-20 w-20 p-2 rounded' />,
            phone: item["Phone Number"], // Using bracket notation to access the key
            email: item["e-mail"] || "N/A",
        };
    });

    return (
        <>
        {ssotData?.length>0?
            <DataTable
                title={<div className='flex flex-row items-center'><span className='me-2'>SSOT</span> <PopOver dataToDisplay={'Add Edit Sittings'} /></div>}
                columns={columns}
                data={data}
                customStyles={customStyles}
                pagination
                dense
                highlightOnHover
                selectableRowsHighlight
                paginationPerPage={50} // Initial page size
                paginationRowsPerPageOptions={[50, 100, 200, 500, 1000]} // Options for users to change page size
            />
        :
        
        <div className="flex justify-center items-center w-full h-full flex-col gap-5">
        <SyncLoader 
          color="#3498db"
          loading={true}
          speedMultiplier={1}
        />
                <p className="loading-text flex flex-row items-center"><span>Loading please wait</span><Icon className='text-lg' icon="eos-icons:three-dots-loading" /></p>

      </div>}
        </>
    );
}

export default SsotTable;
